interface ILed {
  cx: number;
  cy: number;
  color: string;
  showGlowEffect: boolean;
  opacity: number;
  handleLedClick?: () => void;
  canClick: boolean;
}

const Led: React.FC<ILed> = ({ canClick, cx, cy, color, showGlowEffect, opacity, handleLedClick }) => {
  return (
    <>
      <circle
        style={{ cursor: canClick ? "pointer" : "unset" }}
        onClick={handleLedClick}
        cx={cx}
        cy={cy}
        r="3"
        fill={color}
        opacity={opacity}
      />
      {showGlowEffect ? (
        <>
          <circle
            onClick={handleLedClick}
            style={{ cursor: canClick ? "pointer" : "unset" }}
            cx={cx}
            cy={cy}
            r="4"
            fill={color}
            opacity={opacity / 2}
          />
          <circle
            onClick={handleLedClick}
            style={{ cursor: canClick ? "pointer" : "unset" }}
            cx={cx}
            cy={cy}
            r="6"
            fill={color}
            opacity={opacity / 4}
          />
        </>
      ) : null}
    </>
  );
};

export default Led;
